import { Badge } from "../ui/badge";
import { IncidentClockPill } from "./IncidentClockPill";

export const CLASSIFICATIONS = [
  ["pnc", "Possible Non-Compliance (PNC)"], ["near_miss", "Near Miss"], ["no_concern", "No Compliance Concern"],
  ["area_of_concern", "Compliance Opportunity / Area of Concern"], ["reportable_event", "Reportable Event (EOP-004 / OE-417)"],
];
const CLASS_STYLE = {
  pnc: "bg-red-50 text-red-700 border-red-300", near_miss: "bg-amber-50 text-amber-800 border-amber-300",
  no_concern: "bg-slate-50 text-slate-600 border-slate-300", area_of_concern: "bg-blue-50 text-blue-800 border-blue-300",
  reportable_event: "bg-purple-50 text-purple-800 border-purple-300",
};
const COLS = ["Discovered", "How Discovered", "Incident", "Initial Triage", "Classification", "Initial Review",
  "Standard / Req.", "Owner", "Causal Analysis", "Self-Report", "Days Open / Due", "Resolved", "Final Disposition", "Status"];

const clip = (t, n = 90) => (t && t.length > n ? `${t.slice(0, n)}…` : t || "—");

export function IncidentSummaryTable({ rows, labelOf, SOURCES, STATUSES, STATUS_STYLE, onOpen }) {
  return (
    <div className="border border-border bg-white overflow-x-auto" data-testid="incident-summary-table">
      <table className="w-full text-xs min-w-[1500px]">
        <thead className="bg-muted/60 text-left">
          <tr>{COLS.map((c) => <th key={c} className="px-3 py-2 font-semibold whitespace-nowrap border-b border-border">{c}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} onClick={() => onOpen(r.id)} data-testid={`incident-row-${r.id}`}
              className="border-b border-border last:border-0 hover:bg-primary/5 cursor-pointer align-top transition-colors">
              <td className="px-3 py-2 whitespace-nowrap">{r.date_discovered || "—"}</td>
              <td className="px-3 py-2 whitespace-nowrap">{labelOf(SOURCES, r.source)}</td>
              <td className="px-3 py-2 font-semibold min-w-[180px]">{r.title}</td>
              <td className="px-3 py-2 min-w-[200px]">
                {r.triage_date && <div className="text-muted-foreground">{r.triage_date}</div>}{clip(r.triage_notes)}
              </td>
              <td className="px-3 py-2">
                {r.classification
                  ? <Badge variant="outline" className={`rounded-none text-[11px] whitespace-nowrap ${CLASS_STYLE[r.classification] || ""}`} data-testid={`incident-class-${r.id}`}>{labelOf(CLASSIFICATIONS, r.classification)}</Badge>
                  : <span className="text-muted-foreground">Unclassified</span>}
              </td>
              <td className="px-3 py-2 min-w-[200px]">{clip(r.initial_review)}</td>
              <td className="px-3 py-2 whitespace-nowrap">{[r.standard_id, r.requirement].filter(Boolean).join(" ") || "—"}</td>
              <td className="px-3 py-2 whitespace-nowrap">{r.owner || "—"}</td>
              <td className="px-3 py-2 whitespace-nowrap" data-testid={`incident-causal-${r.id}`}>
                {r.causal_analysis ? <span className="text-emerald-700 font-medium">Yes · {r.causal_analysis.status}</span>
                  : r.promoted_to === "pnc" ? <span>PNC record</span> : "No"}
              </td>
              <td className="px-3 py-2 whitespace-nowrap">{r.self_report_filed ? `Filed ${r.self_report_date || ""}` : "No"}</td>
              <td className="px-3 py-2 whitespace-nowrap pr-4 min-w-[230px]" data-testid={`incident-days-${r.id}`}>
                <span className={r.overdue ? "text-red-600 font-semibold" : ""}>{r.days_open ?? "—"}</span>
                <div className="mt-1"><IncidentClockPill clock={r.clock} testId={`incident-clock-${r.id}`} /></div>
              </td>
              <td className="px-3 py-2 whitespace-nowrap">{r.resolution_date || "—"}</td>
              <td className="px-3 py-2 min-w-[200px]">{clip(r.final_disposition)}</td>
              <td className="px-3 py-2">
                <Badge variant="outline" className={`rounded-none text-[11px] ${STATUS_STYLE[r.status] || ""}`}>{labelOf(STATUSES, r.status)}</Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
